import { View, Text, StyleSheet, ScrollView, Pressable, Platform } from 'react-native';
import { useRouter } from 'expo-router';
import Head from 'expo-router/head';
import { ArrowLeft } from 'lucide-react-native';
import { theme } from '@/constants/theme';
import { AccessibilityButton } from '@/components/AccessibilityButton';

export default function PrivacyPolicyScreen() {
  const router = useRouter();

  return (
    <View style={styles.container}>
      {/* SEO/GEO FIX: add page-level canonical metadata for legal pages included in sitemap. */}
      {Platform.OS === 'web' && (
        <Head>
          <title>מדיניות פרטיות | Kursi</title>
          <meta name="description" content="מדיניות הפרטיות של Kursi: אילו נתונים נאספים, לאילו מטרות, וכיצד ניתן לממש זכויות פרטיות." />
          <meta name="robots" content="index,follow" />
          <link rel="canonical" href="https://kursiaii.com/legal/privacy" />
          <meta property="og:title" content="מדיניות פרטיות | Kursi" />
          <meta property="og:description" content="מדיניות הפרטיות של Kursi: אילו נתונים נאספים, לאילו מטרות, וכיצד ניתן לממש זכויות פרטיות." />
          <meta property="og:url" content="https://kursiaii.com/legal/privacy" />
        </Head>
      )}

      <View style={styles.header}>
        <Pressable onPress={() => router.back()} style={styles.backButton}>
          <ArrowLeft color={theme.colors.text} size={24} />
        </Pressable>
        <Text style={styles.headerTitle}>מדיניות פרטיות</Text>
        <View style={styles.placeholder} />
      </View>

      <ScrollView style={styles.content} contentContainerStyle={styles.contentContainer}>
        <Text style={styles.title}>מדיניות פרטיות</Text>
        <Text style={styles.updateDate}>עודכן לאחרונה: _______, 2026</Text>

        <View style={styles.section}>
          <Text style={styles.paragraph}>
            דיניות פרטיות זו נועדה להסדיר את אופן איסוף, השימוש, העיבוד, האחסון וההגנה של מידע אישי הנוגע למשתמשים בפלטפורמת קורסי" - פלטפורמה שמספקת שירות טכנולוגי לאיתור, סינון, דירוג והתאמה של קורסים והכשרות מקצועיות, באמצעות מערכת מבוססת בינה מלאכותית (להלן: "הפלטפורמה"), המופעלת על-ידי השותפות "קורסי" (להלן: "המפעילים").
          </Text>
          <Text style={styles.paragraph}>
            מדיניות פרטיות זו נועדה להסדיר את אופן איסוף, השימוש, העיבוד, האחסון וההגנה של מידע אישי הנוגע למשתמשים באתר, במסגרת השימוש בו ובכלל השירותים, הפונקציות, והמידע הנלווים אליו (להלן: "השירות").
          </Text>
          <Text style={styles.paragraph}>
            אנו מעריכים את הפרטיות שלך ואת החשיבות של שמירה על הנתונים שלך. מדיניות פרטיות זו ("מדיניות הפרטיות") מתארת את נוהלי הפרטיות שלנו עבור הפעילויות המפורטות להלן. בהתאם לזכויותיך, אנו מודיעים לך כיצד אנו אוספים, מאחסנים, ניגשים ומעבדים מידע של המשתמשים בפלטפומה. במדיניות זו, נתונים אישיים ("נתונים אישיים" או "מידע אישי") מתייחסים לכל מידע שבעצמו, או בשילוב עם מידע זמין אחר, יכול לזהות אדם (לרבות באמצעות שם פרטי ושם משפחה, כתובת דוא"ל, מספר זהות או פרטי קשר אחרים).
          </Text>
          <Text style={styles.paragraph}>
            מדיניות הפרטיות מנוסחת בלשון זכר מטעמי נוחות בלבד, אבל היא חלה באופן שווה על כולן וכולם.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>1.	תנאי שימוש</Text>
          <Text style={styles.paragraph}>
            מדיניות הפרטיות מהווה חלק מתנאי השימוש של הפלטפורמה (להלן: "תנאי השימוש"). כל מונח אשר אינו מוגדר במדיניות הפרטיות יפורש בהתאם לתנאי השימוש.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>2.	תחולה</Text>
          <Text style={styles.paragraph}>
            מדיניות זו חלה על הפלטפורמה, הדומיינים, השירותים והשירות. מדיניות הפרטיות זו אינה חלה על אפליקציות, אתרי אינטרנט, מוצרים, שירותים או פלטפורמות של כל צד שלישי שניתן לגשת אליהם באמצעות קישורים שאנו עשויים לספק לך. אתרים אלו נמצאים בבעלות צד שלישי ומופעלים באופן עצמאי מאיתנו, ויש להם מדיניות פרטיות ואיסוף נתונים נפרדים משלהם. כל נתונים אישיים שתספקו לאתרים אלה יהיו כפופים למדיניות הפרטיות של הצד השלישי עצמו. איננו יכולים לקבל אחריות לפעולות או למדיניות של אתרים עצמאיים אלה, ואיננו אחראים לתוכן או לנוהלי הפרטיות של אתרים כאלה.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>3.	הסכמה ועדכון המדיניות</Text>
          <Text style={styles.subsectionTitle}>3.1</Text>
          <Text style={styles.paragraph}>
            אינך מחויב לספק לנו מידע אישי ואתה מאשר בזאת כי מסירת המידע האישי שלך נעשית מבחירתך החופשית ומרצונך להשתמש באתר ו/או בשירות.
          </Text>
          <Text style={styles.subsectionTitle}>3.2</Text>
          <Text style={styles.paragraph}>
            בשימושך בפלטפורמה ו/או בשירות, הנך מסכים למדיניות הפרטיות ולכל איסוף, עיבוד ושיתוף של המידע האישי למטרות המפורטות בה. אם אינך מסכים לתנאי מדיניות הפרטיות, אנא הימנע מכל שימוש בפלטפורמה ו/או בשירות. אנו רשאים לשנות את מדיניות הפרטיות לפי שיקול דעתנו בכל עת, והמשך שימוש בפלטפורמה ו/או בשירות משמעותם הסכמה לתנאי מדיניות הפרטיות העדכניים הרלוונטיים לשימוש זה.
          </Text>
          <Text style={styles.subsectionTitle}>3.3</Text>
          <Text style={styles.paragraph}>
            לתשומת ליבך, מסירת פרטים שגויים או חלקיים, עשויה למנוע ממך להשתמש בפלטפורמה ו/או בשירות, או חלק מהם ו/או לפגוע באפשרות מפעילי האתר לספק לך שירות.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>4.	פעילויות עיבוד</Text>
          <Text style={styles.paragraph}>
            מדיניות הפרטיות זו חלה כאשר אתה מתקשר איתנו על ידי ביצוע אחת מהפעולות הבאות: (i) עשה שימוש בפלטפורמה ובשירות שלנו כמשתמש, לרבות מענה על שאלות באמצעות סוכן הבינה המלאכותית, קבלת המלצות לקורסים ו/או מסירת פרטים לצורך העברתם לספקי קורסים; (ii) ביקור ו/או גלישה באתר האינטרנט של הפלטפורמה ו/או בכל אתר, דף נחיתה או ממשק דיגיטלי אחר המקושר למדיניות פרטיות זו; (iii) מקבל מאיתנו כל תקשורת לרבות ניוזלטרים, מיילים, שיחות או הודעות טקסט.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>5.	איזה מידע אישי אנו אוספים וכיצד</Text>
          <Text style={styles.paragraph}>
            המפעילים עשויים לאסוף ו/או לקבל מידע אישי אודות משתמשים בדרכים המפורטות להלן, הכול בהתאם להוראות כל דין, לתנאי שימוש אלו ולמדיניות הפרטיות של הפלטפורמה:
          </Text>
          <Text style={styles.subsectionTitle}>5.1</Text>
          <Text style={styles.paragraph}>
            מידע הנמסר ישירות על-ידי המשתמש. כאשר המשתמש יוצר קשר עם המפעילים באמצעות הפלטפורמה, בדואר אלקטרוני, בטופס מקוון או בכל אמצעי אחר, הוא עשוי להתבקש למסור פרטים אישיים מסוימים, לרבות שם, כתובת דואר אלקטרוני, מספר טלפון ופרטי התקשרות נוספים.
          </Text>
          <Text style={styles.paragraph}>
            בנוסף, כל מידע שיימסר במסגרת תוכן הפנייה יישמר וישמש לצורך טיפול בפנייה ומתן מענה.
          </Text>
          <Text style={styles.paragraph}>
            המשתמש מתבקש להימנע ממסירת מידע רגיש, מידע פיננסי, או מידע הנוגע לצדדים שלישיים ללא קבלת הסכמתם המפורשת והמתאימה.
          </Text>
          <Text style={styles.subsectionTitle}>5.2</Text>
          <Text style={styles.paragraph}>
            מידע הנמסר במסגרת השימוש בפלטפורמה. בעת השימוש בפלטפורמה ובשירותי ההתאמה, המפעילים עשויים לאסוף מידע הנמסר מרצון על-ידי המשתמש, לרבות: (א) תשובות לשאלות סוכן הבינה המלאכותית; (ב) פרטי קשר שנמסרו לצורך העברת פנייה לספקי קורסים (שם, מספר טלפון וכיו"ב); (ג) משוב, פניות לתמיכה או הערות שנמסרו על-ידי המשתמש.
          </Text>
          <Text style={styles.subsectionTitle}>5.3</Text>
          <Text style={styles.paragraph}>
            מאחר שהשימוש בפלטפורמה אינו כרוך ברישום חובה או בביצוע תשלומים מצד המשתמש, המפעיל אינו אוסף דרך הפלטפורמה, כברירת מחדל, פרטי חשבון או פרטי תשלום, אלא אם הדבר יידרש בעתיד במסגרת שירותים נוספים, בכפוף להודעה מתאימה ולמדיניות פרטיות מעודכנת.
          </Text>
          <Text style={styles.subsectionTitle}>5.4</Text>
          <Text style={styles.paragraph}>
            מידע טכני ומידע הנאסף באופן אוטומטי. בעת אינטראקציה של המשתמש עם הפלטפורמה, עשוי להיאסף מידע טכני וסטטיסטי באופן אוטומטי, לרבות: (א) סוג ודגם המכשיר; (ב) מערכת הפעלה ודפדפן; (ג) כתובת IP; (ד) נתוני שימוש ודפוסי גלישה; (ה) זמני גישה ופעולות שבוצעו בפלטפורמה.
          </Text>
          <Text style={styles.paragraph}>
            מידע זה עשוי להיאסף באמצעות קבצי Cookies, יומני שרת, וכלי ניתוח וטכנולוגיות דומות אחרות, והכול בהתאם למדיניות העוגיות של הפלטפורמה, ככל שפורסמה.
          </Text>
          <Text style={styles.subsectionTitle}>5.5</Text>
          <Text style={styles.paragraph}>
            מידע המתקבל מצדדים שלישיים. המפעיל עשוי לקבל מידע אישי אודות המשתמש גם מצדדים שלישיים, ובכלל זה: (א) נתוני שימוש וניתוח מצד ספקי שירותי אנליטיקה וטכנולוגיה (כגון Google Analytics וכיוצא באלה); (ב) פרטי זיהוי בסיסיים ונתוני חשבון מצד פלטפורמות מדיה חברתית או ספקי שירותי התחברות, ככל שהמשתמש יבחר בעתיד להתחבר לפלטפורמה באמצעותם; (ג) מידע שמקורו בשירותי תקשורת של צדדים שלישיים, ככל שהמשתמש יעניק למפעיל הרשאה לגשת למידע כאמור; (ד) מידע מגורמים חיצוניים, לרבות גופים ציבוריים או פרטיים, לצרכי מניעת הונאה, אבטחת מידע או עמידה בהוראות דין.
          </Text>
          <Text style={styles.subsectionTitle}>5.6</Text>
          <Text style={styles.paragraph}>
            מימוש זכויות המשתמש. משתמש הסבור כי מידע אישי הנוגע אליו נאסף או עובד שלא כדין, או המבקש לממש את זכויותיו לעיון, תיקון או מחיקה של מידע אישי, רשאי לפנות למפעילים באמצעות פרטי הקשר המפורטים בסעיף "יצירת קשר" בתנאי השימוש או במדיניות הפרטיות.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>6.	קבצי לוג </Text>
          <Text style={styles.subsectionTitle}>6.1</Text>
          <Text style={styles.paragraph}>
            כאשר אתה עושה שימוש בפלטפורמה שלנו אנו עשויים להשתמש בקבצי לוג. המידע המופיע בקבצי הלוג כולל כתובת IP, סוג דפדפן, חותמת תאריך/זמן, עמודי הפניה/יציאה, פעולות סינון, נתוני הקלקות וכל מידע אחר שעשוי להימסר לנו מהדפדפן שלך. אנו עשויים להשתמש במידע כאמור לצורך ניתוח מגמות, ניהול המערכת, מעקב אחר תעבורת הגולשים במערכת ולצורך איסוף מידע דמוגרפי. ידוע לך כי השימוש במידע כאמור ייעשה בהתאם למטרות המפורטות במדיניות זו.
          </Text>
          <Text style={styles.subsectionTitle}>6.2</Text>
          <Text style={styles.paragraph}>
            עוגיות וטכנולוגיות דומות. במסגרת הפלטפורמה והשירות, אנו עשויים להשתמש ב-״עוגיות", קבצי זיהוי אנונימיים וטכנולוגיות מעקב אחרות. עוגיות הן קבצי טקסט קטנים שנשמרים על ידי הדפדפן במכשיר של המשתמש בעת ביקור באתר. עוגיות מאפשרות לפלטפורמה לזהות את המשתמש בפעמים הבאות שיגלוש באתר, לאסוף נתונים סטטיסטיים, ולשפר את חוויית השימוש בפלטפורמה. אתה יכול להורות לדפדפן שלך לסרב לכל העוגיות או לציין מתי נשלחת עוגיה, אולם אנו מפעילים מנגנון ניהול הסכמות ייעודי בפלטפורמה המאפשר לך לבחור את סוגי העוגיות המאושרים על ידך - אנו מחויבים ליידע את המשתמשים על כך, ולבקש את הסכמתם המפורשת והמוקדמת לשימוש בעוגיות שאינן חיוניות באמצעות מנגנון ניהול ההסכמות (Consent Manager) המופיע עם הכניסה לפלטפורמה.
          </Text>
          <Text style={styles.subsectionTitle}>6.3</Text>
          <Text style={styles.paragraph}>
            מטרות השימוש בעוגיות בפלטפורמה: (א) תפעול תקין של השירותים: העוגיות נועדו לאפשר לנהל את השירותים המוצעים בפלטפורמה בצורה יעילה, כגון ניהול התחברויות, טעינת תוכן מותאם אישית, וניהול תהליכי רכישה שימוש; (ב) איסוף נתונים סטטיסטיים: העוגיות מסייעות באיסוף נתונים אנונימיים המאפשרים לנתח את התנהגות המשתמשים בפלטפורמה, לזהות דפוסי שימוש, ולשפר את חוויית הגלישה; (ג) התאמה אישית: באמצעות העוגיות, ניתן להתאים את תוכן הפלטפורמה, הפרסומות והשירותים לצרכים ולהעדפות של המשתמש, לדוגמה, הצגת תוכן מותאם אישית בהתבסס על מיקום גיאוגרפי או העדפות קודמות; (ד) אבטחת מידע: העוגיות תורמות לזיהוי משתמשים ולמניעת גישה בלתי מורשית לפלטפורמה ו/או לשירותים.
          </Text>
          <Text style={styles.subsectionTitle}>6.4</Text>
          <Text style={styles.paragraph}>
            חלק מהעוגיות עשויות לאסוף מידע אישי, כגון כתובת IP, נתוני מיקום, תחומי עניין או מזהים טכנולוגיים. אנו מחויבים ליידע את המשתמשים על כך, ולבקש את הסכמתם לשימוש בעוגיות שאינן חיוניות. 
          </Text>
          <Text style={styles.paragraph}>
            חסימה או הסרה של עוגיות: המשתמש יכול לנהל את הגדרות העוגיות דרך הדפדפן שלו, ולבחור האם לאפשר או לחסום עוגיות מסוימות. ניתן לעשות זאת דרך הגדרות הדפדפן, בהתאם להוראות המפורטות בעזרה של הדפדפן בו הוא משתמש. תכונת העזרה ( the "Help" feature ) ברוב הדפדפנים תספק מידע כיצד לקבל קבצי "עוגיות", להשבית קבצי "עוגיות" או להודיע לך בעת קבלת קובץ "עוגיות" חדש. 
          </Text>
          <Text style={styles.paragraph}>
            השפעת החסימה: חסימת עוגיות מסוימות עלולה לפגוע בתפקוד התקין של הפלטפורמה או בחוויית השימוש, לרבות קבלת המלצות מותאמות. אם אינך מקבל עוגיות, ייתכן שלא תוכל להשתמש בחלק מהתכונות של השירות שלנו ואנו ממליצים להשאיר אותן מופעלות. 
          </Text>
          <Text style={styles.paragraph}>
            באמצעות המשך שימוש בפלטפורמה, המשתמש מאשר את השימוש בעוגיות בהתאם למדיניות זו, אלא אם הביע התנגדות מפורשת דרך הגדרות הדפדפן או מנגנון ניהול ההסכמות באתר (אם קיים).
          </Text>
          <Text style={styles.subsectionTitle}>6.5</Text>
          <Text style={styles.paragraph}>
            עדכונים למדיניות העוגיות: מפעילי הפלטפורמה שומרים לעצמם את הזכות לעדכן מדיניות זו מעת לעת. כל עדכון יפורסם בפלטפורמה, והמשתמשים מתבקשים לעיין במדיניות הפרטיות באופן תקופתי כדי להתעדכן בשינויים. בכל שאלה או הבהרה בנוגע לשימוש בעוגיות, ניתן לפנות אלינו באמצעות פרטי הקשר המופיעים פלטפורמה.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>7.	Google Analytics וכלים נוספים</Text>
          <Text style={styles.subsectionTitle}>7.1</Text>
          <Text style={styles.paragraph}>
            אנו עשויים להשתמש גם בכלי של Google Analytics כדי לעזור לנו להבין כיצד המשתמשים שלנו משתמשים בפלטפורמה ובשירות. תוכל לקרוא עוד על האופן שבו Google משתמשת בנתונים האישיים שלך כאן: https://www.google.com/intl/iw/policies/privacy /
          </Text>
          <Text style={styles.paragraph}>
            אתה יכול גם לבטל את הסכמתך ל-Google Analytics כאן:
          </Text>
          <Text style={styles.paragraph}>
            http s://tools.google.com/dlpage/gaoptout 
          </Text>
          <Text style={styles.paragraph}>
            באפשרותך למנוע את השימוש בנתוניך על ידי Google Analytics באמצעות הורדה והתקנה של Google Analytics Opt-out Browser Add-on, שנמצא כאן:
          </Text>
          <Text style={styles.paragraph}>
             https://tools.google.com/dlpage/gaoptout. 
          </Text>
          <Text style={styles.paragraph}>
            יובהר כי השימוש בכלי זה ובכלים דומים של צדדים שלישיים (כגון Meta Pixel) כפוף לאישור ספציפי של עוגיות "סטטיסטיקה" או "שיווק" במנגנון ניהול ההסכמות שלנו.
          </Text>
          <Text style={styles.subsectionTitle}>7.2</Text>
          <Text style={styles.paragraph}>
            מבלי לגרוע מהאמור לעיל, במסגרת השימוש בפלטפורמה רשאים המפעילים לאסוף מידע הנוגע להעדפות המשתמש, תחומי העניין שלו ואופן השימוש שלו בשירותים, וזאת לצורך שיפור השירותים, התאמת תכנים והצגת הצעות כלליות במסגרת הפלטפורמה.
          </Text>
          <Text style={styles.paragraph}>
            עם זאת, מובהר ומוסכם בזאת כי לא יישלח למשתמש כל חומר פרסומי, שיווקי או מסחרי, לרבות ניוזלטרים, הודעות דוא"ל, הודעות טקסט (SMS), הודעות יישומים או כל אמצעי תקשורת דומה, אלא לאחר קבלת הסכמתו המפורשת, המוקדמת והנפרדת לכך, ובהתאם להוראות כל דין.
          </Text>
          <Text style={styles.paragraph}>
            ככל שהמשתמש ייתן את הסכמתו כאמור, רשאיים המפעילים להשתמש בנתונים האישיים של המשתמש לצורך משלוח מסרים שיווקיים מותאמים ו/או להצגת פרסומות ממוקדות, לרבות במסגרת הפלטפורמה, באתרי אינטרנט אחרים שבבעלות המפעילים או מי מטעמם, ובפלטפורמות חיצוניות שונות, לרבות רשתות חברתיות (כגון Facebook, LinkedIn, X (Twitter) וכיוצא באלה).
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>8.	דיוור אלקטרוני, הסכמה וביטול קבלת הודעות לשם ציות לסעיף 30א לחוק התקשורת (בזק ושידורים) תשמ"ב - 1982 ("חוק הספאם") </Text>
          <Text style={styles.subsectionTitle}>8.1</Text>
          <Text style={styles.paragraph}>
            בעת הזנת פרטיך האישיים בפלטפורמה, אנו עשויים לבקש ממך לאשר באופן מפורש, באמצעות סימון תיבה ייעודית או פעולה אקטיבית אחרת, את הסכמתך לקבלת הודעות שיווקיות מטעמנו בלבד. רק לאחר מתן הסכמה מפורשת זו, יהיו מפעילי הפלטפורמה רשאים לשלוח אליך דיוור אלקטרוני, הודעות SMS או כל אמצעי תקשורת אלקטרוני אחר.
          </Text>
          <Text style={styles.subsectionTitle}>8.2</Text>
          <Text style={styles.paragraph}>
            בכל הודעה שיווקית שתישלח יוצג מנגנון ביטול מנוי (Unsubscribe) נגיש, אשר יאפשר לך לבטל את הסכמתך לקבלת הודעות נוספות – באופן פשוט, מהיר וללא עלות. ביטול ההסכמה יחול על כל דיוור עתידי מטעם הפלטפורמה, ללא גריעה מזכויותיך על פי דין.
          </Text>
          <Text style={styles.subsectionTitle}>8.3</Text>
          <Text style={styles.paragraph}>
            אנו נשמור תיעוד מלא של מתן ההסכמה ושל בקשות הביטול, וננקוט בכל האמצעים הטכניים והארגוניים הנדרשים על מנת לעמוד בדרישות חוק התקשורת (סעיף 30א – "חוק הספאם") ולהבטיח כי הודעות יישלחו בהתאם להוראות החוק בלבד.
          </Text>
          <Text style={styles.subsectionTitle}>8.4</Text>
          <Text style={styles.paragraph}>
            אנו נשלח הודעות שיווקיות אך ורק בהתאם להסכמות שהתקבלו בפועל. מובהר בזאת כי המפעילים לא יישאו בכל אחריות בנוגע להפצת דואר אלקטרוני מסוג "דואר ספאם" שאינו בשליטתם הישירה, בהתאם להוראות הדין.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>9.	אילו מטרות אנו משתמשים במידע אישי</Text>
          <Text style={styles.paragraph}>
            אנו נשתמש במידע האישי על פי מדיניות הפרטיות, על פי כל דין ולמטרות המפורטות להלן:
          </Text>
          <Text style={styles.paragraph}>
            לספק שירות ותמיכה טכנית, לספק פתרון לתקלות טכניות, לנהל את הקשר שלנו איתך ולאסוף מידע על האופן שבו אתה משתמש בפלטפורמה ובשירות שלנו;
          </Text>
          <Text style={styles.paragraph}>
            לתחזק ולשפר את השירותים והתכונות שלנו - אנו מבצעים באופן פנימי ניתוח סטטיסטי ואחר על מידע שאנו אוספים, כולל נתוני שימוש, נתוני מכשירים, נתוני הפניות, נתוני שאלות ותגובה ומידע מתגי עמודים, כדי לנתח ולמדוד התנהגות ומגמות של משתמשים, כדי להבין כיצד אנשים משתמשים בפלטפורמה ובשירות שלנו, וכן לנטר, לפתור בעיות ולשפר את השירותים שלנו, כולל לעזור לנו להעריך ולעצב תכונות חדשות.
          </Text>
          <Text style={styles.paragraph}>
            לצרכי אפיון, מחקר, פרסום והתאמת תכנים שיווקיים בפלטפורמות השונות;
          </Text>
          <Text style={styles.paragraph}>
            בהתאם לדין ובכפוף להסכמתך כאמור בסעיף 8 לעיל, נשתמש בכתובת הדוא"ל שלך וכל אמצעי אחר כדי לשלוח לך עדכונים וחדשות בנוגע לשירותינו תוך התאמת תכנים שיווקיים כמפורט. ככל שלא תהיה מעוניין לקבל הודעות אלו, ביכולתך להסיר עצמך מרשימת התפוצה בכל רגע על ידי לחיצה על קישור ההסרה שיופיע במיילים השיווקייםו/או באמצעות האתר.
          </Text>
          <Text style={styles.paragraph}>
            כדי לאכוף את תנאי השימוש שלנו;
          </Text>
          <Text style={styles.paragraph}>
            כדי למנוע פעילויות שעלולות להיות בלתי חוקיות.
          </Text>
          <Text style={styles.paragraph}>
            איננו משתמשים במידע אישי מלבד כפי שמתואר במדיניות פרטיות זו ללא הסכמת המשתמשים שלנו. אנחנו לא מוכרים את המידע האישי של המשתמשים, וגם לא הופכים אותו לזמין לצדדים שלישיים ללא רשות המשתמש.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>10.	שיתוף המידע האישי עם צדדים שלישיים</Text>
          <Text style={styles.paragraph}>
            לא נעביר את המידע שמסרת לנו לצדדים שלישיים, למעט במקרים הבאים:
          </Text>
          <Text style={styles.subsectionTitle}>10.1</Text>
          <Text style={styles.paragraph}>
            לפי הסכמתך או במקרה שהדבר כרוך במתן השירות. כך למשל, לנותני שירותים אשר מסייעים לנו באחסון המידע שתעלה לאתר, אבטחת מידע, בתפעול האתר ובפיתוח חלק מהכלים שזמינים עבורך דרך האתר ומשמשים לניתוח המידע שלך. מידע כאמור עשוי להיות מועבר גם לספקים במדינות אחרות, לרבות בארה"ב. 
          </Text>
          <Text style={styles.subsectionTitle}>10.2</Text>
          <Text style={styles.paragraph}>
            במקרה של כל מחלוקת, טענה, תביעה, דרישה או הליכים משפטיים, או במקרה שתפר את תנאי השימוש או את מדיניות הפרטיות או אם תבצע פעולות הנחזות כמנוגדות לדין, נוכל להעביר את המידע ליועצים שלנו או מי מטעמם כדי לבצע את הבדיקות והפעולות הנדרשות לטיפול בכך.
          </Text>
          <Text style={styles.subsectionTitle}>10.3</Text>
          <Text style={styles.paragraph}>
            ככל שהעברת המידע נחוצה כדי למנוע נזק גוף או רכוש (לך או לצד שלישי) או בקשר לחקירה לחשדות למעשים בלתי חוקיים.
          </Text>
          <Text style={styles.subsectionTitle}>10.4</Text>
          <Text style={styles.paragraph}>
            במקרה בו נדרש על פי חוק להעביר לצדדים שלישיים את פרטיך האישיים והמידע שנאסף על פעילותך בפלטפורמה, לרבות אם יתקבל בידינו צו שיפוטי המורה לנו למסור את פרטיך או את המידע אודותיך לצד שלישי או במענה לבקשה מרשות אכיפה או רשות ממשלתית או ציבורית אחרת.
          </Text>
          <Text style={styles.subsectionTitle}>10.5</Text>
          <Text style={styles.paragraph}>
            ככל שמפעילי הפלטפורמה יעבירו את פעילותם או חלק ממנה לתאגיד אחר, הם יהיו זכאים להעביר לתאגיד כאמור את המידע שנאסף אודותיך, או בכל הנוגע לשינוי מבנה תאגידי, רכישת הפלטפורמה או נכסי מפעילי הפלטפורמה ובדיקות בנוגע לאירועים כאמור.
          </Text>
          <Text style={styles.subsectionTitle}>10.6</Text>
          <Text style={styles.paragraph}>
            העברת נתונים למעבירי הקורסים. במסגרת השימוש בפלטפורמה, וככל שהמשתמש יבחר להביע עניין בקורס מסוים ולתת את הסכמתו המפורשת לכך, יועברו לספק הקורס הרלוונטי פרטים אישיים מזהים אודות המשתמש, כפי שנמסרו על-ידו (כגון שם ומספר טלפון), וזאת אך ורק לצורך: (א) יצירת קשר עם המשתמש בנוגע לקורס שבו הביע עניין; (ב) מתן מידע נוסף על הקורס; (ג) תיאום הרשמה, השתתפות או התקשרות אפשרית בין המשתמש לבין ספק הקורס; (ד) ניהול הקשר בין המשתמש לבין ספק הקורס בקשר לפנייה שיזם המשתמש באמצעות הפלטפורמה.
          </Text>
          <Text style={styles.subsectionTitle}>	10.6.1</Text>
          <Text style={styles.paragraph}>
            מובהר כי הפלטפורמה אינה צד לכל התקשרות שתיווצר בין המשתמש לבין ספק הקורס, ואינה אחראית לאופן שבו ספק הקורס יעשה שימוש בפרטי המשתמש לאחר שהועברו אליו בהתאם להסכמת המשתמש ובהתאם לדין. 
          </Text>
          <Text style={styles.subsectionTitle}>10.6.2</Text>
          <Text style={styles.paragraph}>
            ככל שבעתיד יוצעו בפלטפורמה פעילויות משותפות עם צדדים שלישיים, יחולו הוראות דומות, ולפיהן יועבר מידע אישי לצדדים שלישיים רק במידה הדרושה לצורך ניהול הפעילות הרלוונטית ורק לאחר קבלת הסכמת המשתמש, ובהתאם לתנאי השימוש ולמדיניות הפרטיות של הפלטפורמה.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>11.	שירותי מדיה חברתית, אינטגרציות וקישורים לשירותי צד שלישי</Text>
          <Text style={styles.subsectionTitle}>11.1</Text>
          <Text style={styles.paragraph}>
            המפעיל עשוי לאפשר, כעת או בעתיד, שילוב של הפלטפורמה עם שירותים, יישומים ואתרים של צדדים שלישיים, לרבות פלטפורמות מדיה חברתית, ספקי שירותי אימות זהות דיגיטלית, שירותי אנליטיקה ויישומים נוספים (כגון Google, Facebook, X (Twitter), LinkedIn וכיוצא באלה). במסגרת שילוב כאמור, ייתכן שתתאפשר למשתמש האפשרות:
          </Text>
          <Text style={styles.paragraph}>
            להתחבר לפלטפורמה באמצעות חשבון צד שלישי;
          </Text>
          <Text style={styles.paragraph}>
            לשתף מידע מהפלטפורמה לשירות חיצוני;
          </Text>
          <Text style={styles.paragraph}>
            או לאפשר לפלטפורמה לקבל מידע בסיסי משירותי צד שלישי, בהתאם להרשאות שיינתנו על-ידי המשתמש.
          </Text>
          <Text style={styles.paragraph}>
            בעת שימוש באינטגרציות אלה, ייתכן כי מידע אישי של המשתמש יועבר לשירותי הצד השלישי הרלוונטיים, ו/או ייאסף מהם על-ידי המפעילים, בהתאם להרשאות שיינתנו ולמדיניות של אותם גורמים. מןבהר בזאץ כח המפעילים אינם מחזיקים, אינם מפעילים ואינם שולטים במערכות, באתרים או ביישומים של צדדים שלישיים כאמור, והמשתמש נדרש לעיין במדיניות הפרטיות, בתנאי השימוש ובהצהרות האבטחה של אותם שירותים חיצוניים טרם השימוש בהם.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>12.	קישורים ושירותי צד שלישי</Text>
          <Text style={styles.subsectionTitle}>12.1</Text>
          <Text style={styles.paragraph}>
            הפלטפורמה עשויה לכלול קישורים, הפניות או אפשרויות אינטראקציה עם אתרים, יישומים ושירותים של צדדים שלישיים, לרבות אתרי ספקי קורסים, מערכות הרשמה חיצוניות, פלטפורמות תשלום, רשתות חברתיות או שירותים טכנולוגיים אחרים (להלן: "שירותי צד שלישי").
          </Text>
          <Text style={styles.subsectionTitle}>12.2</Text>
          <Text style={styles.paragraph}>
            בעת שימוש בקישורים אלה או מעבר לשירותי צד שלישי:
          </Text>
          <Text style={styles.paragraph}>
            ייתכן כי אותם גורמים יאספו מידע אישי אודות המשתמש;
          </Text>
          <Text style={styles.paragraph}>
            תחול על המשתמש מדיניות הפרטיות ותנאי השימוש של אותם גורמים בלבד;
          </Text>
          <Text style={styles.paragraph}>
            והמפעיל לא יישא בכל אחריות לאיסוף המידע, לשימוש בו, לאבטחתו או לכל פעולה אחרת שיבוצע על-ידי אותם צדדים שלישיים.
          </Text>
          <Text style={styles.paragraph}>
            המפעילים אינם מתחייבים לזמינותם, לתקינותם, לאיכותם או לאבטחתם של שירותי צד שלישי, ואינם אחראים לכל נזק, הפסד או הוצאה שייגרמו למשתמש עקב שימוש בהם או הסתמכות עליהם.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>13.	אבטחת מידע והגנה על מידע אישי</Text>
          <Text style={styles.subsectionTitle}>13.1</Text>
          <Text style={styles.paragraph}>
            המפעילים נוקטים באמצעים ארגוניים, טכניים ופיזיים סבירים ומקובלים בתעשייה, אשר נועדו להגן על המידע האישי של המשתמשים מפני אובדן מקרי, גישה בלתי מורשית, שימוש לרעה, שינוי, חשיפה או השמדה. אמצעי אבטחה אלה כוללים, בין היתר, בקרות גישה, הצפנה במידת הצורך, מערכות ניטור, נהלי אבטחת מידע פנימיים ושימוש בספקי תשתית מאובטחים, בהתאם לסטנדרטים המקובלים.
          </Text>
          <Text style={styles.subsectionTitle}>13.2</Text>
          <Text style={styles.paragraph}>
            על אף האמור לעיל, המשתמש מודע ומסכים לכך כי לא ניתן להבטיח אבטחה מוחלטת של מערכות מידע או תקשורת באמצעות האינטרנט, וכי המפעילים אינם מתחייבים שהפלטפורמה, שרתיה או מאגרי המידע יהיו חסינים לחלוטין מפני חדירה, תקלה, מתקפת סייבר או גישה בלתי מורשית.
          </Text>
          <Text style={styles.subsectionTitle}>13.3</Text>
          <Text style={styles.paragraph}>
            במקרה של אירוע אבטחת מידע או הפרת נתונים אישיים, המפעילים יפעלו בהתאם להוראות הדין החל, ובכלל זה יודיע לרשויות המוסמכות ולמשתמשים הרלוונטיים ככל שנדרשים לעשות זאת על פי חוק.
          </Text>
          <Text style={styles.subsectionTitle}>13.4</Text>
          <Text style={styles.paragraph}>
            בכל שאלה או פנייה הנוגעת לאבטחת מידע או לסודיות המידע האישי, ניתן ליצור קשר עם המפעילים באמצעות פרטי הקשר המפורטים באתר.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>14.	זכויות המשתמש והגנה על פרטיותו</Text>
          <Text style={styles.subsectionTitle}>14.1</Text>
          <Text style={styles.paragraph}>
            המפעילים מכבדים את פרטיות המשתמשים ופועלים לצמצום איסוף המידע האישי למידע הדרוש בלבד לצורך מתן השירות, תפעול הפלטפורמה ושיפורם, וכן לשמירה על מידע מדויק, שלם ומעודכן ככל האפשר.
          </Text>
          <Text style={styles.subsectionTitle}>14.2</Text>
          <Text style={styles.paragraph}>
            בהתאם להוראות חוק הגנת הפרטיות, התשמ"א–1981, והדינים החלים, המשתמש זכאי: (א) לעיין במידע האישי שנשמר אודותיו במאגרי המידע של המפעילים; (ב) לבקש לתקן מידע שאינו נכון, אינו שלם, אינו ברור או אינו מעודכן; (ג) לבקש את מחיקת המידע, ככל שהדבר אפשרי בהתאם לדין ולצרכים לגיטימיים של המפעילים.
          </Text>
          <Text style={styles.subsectionTitle}>14.3</Text>
          <Text style={styles.paragraph}>
            מימוש זכויות אלה יתבצע באמצעות פנייה בכתב למפעילי הפלטפורמה באמצעות שליחת דוא"ל ל-kursi.online.il@gmail.com, בצירוף פרטים מזהים מתאימים לצורך אימות הבקשה.
          </Text>
          <Text style={styles.subsectionTitle}>14.4</Text>
          <Text style={styles.paragraph}>
            ככל שהמשתמש הינו עובד, מועמד או לקוח של אחד מספקי הקורסים או של משתמש בפלטפורמה, ומידע הנוגע אליו מצוי כחלק מנתוניו של אותו צד שלישי, המשתמש רשאי לפנות למפעילים לבירור, והמפעילים יפעלו במידת האפשר להפנות את הבקשה לגורם הרלוונטי או לסייע בטיפול בה, בהתאם לדין.
          </Text>
          <Text style={styles.subsectionTitle}>14.5</Text>
          <Text style={styles.paragraph}>
            מובהר כי מימוש זכויות המשתמש כפוף להוראות הדין, לזכויות צדדים שלישיים ולצרכים תפעוליים, רגולטוריים ומשפטיים של המפעיל.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>15.	שמירה ומחיקה של מידע</Text>
          <Text style={styles.paragraph}>
            אנו נשמור את הנתונים האישיים שלך רק כל עוד נחוץ למטרה שלשמה נאספו ובמידה הנדרשת על פי החוק החל. כאשר איננו זקוקים עוד לנתונים אישיים, נסיר אותם מהמערכות שלנו ו/או ננקוט בצעדים להפיכתם לאנונימית. אם תרצה לבקש כי מידע שתעלה למערכת יימחק לאחר של 7 שנים, אנא צור עמנו קשר דרך הפלטפורמה ונפעל באופן סביר כדי לטפל בבקשתך.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>16.	הדין החל וסמכות שיפוט</Text>
          <Text style={styles.paragraph}>
            על מדיניות הפרטיות יחולו אך ורק חוקי מדינת ישראל מבלי לתת תוקף לדיניה הנוגעים לניגוד דינים ולבתי המשפט המוסמכים של תל-אביב תהיה סמכות שיפוט בלעדית בכל מחלוקת בקשר עם התחייבות זו.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>17.	הפרדה</Text>
          <Text style={styles.paragraph}>
            אם יקבע בפסק דין סופי וחלוט או בהחלטה שיפוטית סופית וחלוטה כי אין תוקף לחלק כלשהו במדיניות הפרטיות, יהא בטל אותו חלק בלבד וכל שאר חלקי מדיניות הפרטיות יעמדו בתוקפם.
          </Text>
        </View>
      </ScrollView>

      <AccessibilityButton />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: theme.spacing.md,
    paddingVertical: theme.spacing.md,
    paddingTop: Platform.OS === 'ios' ? 50 : theme.spacing.lg,
    backgroundColor: theme.colors.backgroundLight,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.border,
  },
  backButton: {
    padding: theme.spacing.xs,
  },
  headerTitle: {
    fontSize: 18,
    fontFamily: theme.fonts.bold,
    color: theme.colors.text,
  },
  placeholder: {
    width: 40,
  },
  content: {
    flex: 1,
  },
  contentContainer: {
    padding: theme.spacing.lg,
    paddingBottom: theme.spacing.xl * 2,
  },
  title: {
    fontSize: 28,
    fontFamily: theme.fonts.bold,
    color: theme.colors.text,
    textAlign: 'center',
    marginBottom: theme.spacing.sm,
  },
  updateDate: {
    fontSize: 14,
    fontFamily: theme.fonts.regular,
    color: theme.colors.textLight,
    textAlign: 'center',
    marginBottom: theme.spacing.xl,
  },
  section: {
    marginBottom: theme.spacing.lg,
  },
  sectionTitle: {
    fontSize: 20,
    fontFamily: theme.fonts.bold,
    color: theme.colors.primary,
    marginBottom: theme.spacing.md,
    textAlign: 'right',
  },
  subsectionTitle: {
    fontSize: 16,
    fontFamily: theme.fonts.bold,
    color: theme.colors.primary,
    marginBottom: theme.spacing.xs,
    textAlign: 'right',
  },
  paragraph: {
    fontSize: 16,
    fontFamily: theme.fonts.regular,
    color: theme.colors.text,
    lineHeight: 24,
    textAlign: 'right',
    marginBottom: theme.spacing.sm,
  },
});